import Vue from 'vue'
import Vuex from 'vuex'

import user from './user'
import shared from './shared'
import browser from './browser'
import entry from './entry.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    shared,
    browser,
    entry
  },
  strict: process.env.NODE_ENV !== 'production'
  // plugins: debug ? [createLogger()] : []
})
